require("./extantCostDetails.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");
const Immutable = require("immutable");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

// @helpers
const { getFormattedString,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require("utilities/currencyHelper");

// @constants
const {
  POTENTIAL_SELL_FUNDS_COSTS,
  POTENTIAL_COST,
  POTENTIAL_COST_TYPE,
} = require('constants/index');

class ExtantCostDetails extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
    }

    buildLeftColumn() {
        const { immInvestmentFunds, immAccount } = this.props;
        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const currencyObject = Immutable.Map().merge({
            amount: immInvestmentFunds.getIn(["steps", 0, "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        });
        const amountInvestment = getFormattedString(currencyObject);
        const contractNumber = immAccount.get("contractNumber");
        const owner = immAccount.get("accountHolder") || "";
        const acountCodbban = immAccount.getIn([
            "ibanComplex",
            "codbban",
        ]);
        const accountBalanceObject = Immutable.Map().merge({
            amount: immAccount.getIn(["balance", "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        })
        const accountBalance = getFormattedString(accountBalanceObject);
        const accountLabel = `${immAccount.get(
            "alias"
        )} ...${acountCodbban.substring(
            acountCodbban.length - 5,
            acountCodbban.length - 1
        )} (Saldo: ${accountBalance})`;
        return (
            <div className="hire-investment-description__left-column-container">
                <div className="hire-investment-description__column-title">
                    <FormattedText value="brokerAlternativeFundsBuyStep2-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label="brokerAlternativeFundsBuyStep2-fundToBuy"
                    data={fundName}
                />
                <BrokerDataItem
                    label="brokerAlternativeFundsBuyStep2-estimatedAmount"
                    data={amountInvestment}
                    tooltipTitleKey={`brokerAlternativeFundsBuyStep2-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerAlternativeFundsBuyStep2-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra fondos/paso 2"
                    eventTag={formatText(
                        "brokerAlternativeFundsBuyStep2-orderData_estimatedAmount_eventTag"
                    )}
                    complexTooltip
                />
                <BrokerDataItem
                    label="brokerAlternativeFundsBuyStep2-extantCost_first_holder"
                    data={owner}
                />
                <BrokerDataItem
                    label="brokerAlternativeFundsBuyStep2-extantCost_associated_account"
                    data={accountLabel}
                />
            </div>
        );
    }

    buildRightColumn() {
        const { immInvestmentFunds } = this.props;
        const dataExAnt = immInvestmentFunds.getIn(['fetchDataExt', 'response']);
        let data, potentialSellCosts, potentialSellCostsText;
        if (immInvestmentFunds.get('fetchingDataExt')) {
            data = <LoadingSection />;
        } else if (dataExAnt) {
            data = dataExAnt.map((item, index) => (
                item.get('type')  !== POTENTIAL_COST &&
                (
                    <BrokerExAntSection
                        context="brokerAlternativeFundsBuyStep2"
                        eventCategory="orden compra fondosAlternativos/paso 2"
                        section={item}
                        key={index}
                        complexTooltip={true}
                    />
                )
            ));

            potentialSellCosts  = dataExAnt.find(
                (item) => item.get('type') === POTENTIAL_COST
            );

        } else if (immInvestmentFunds.get('isFetchedPre') === false) {
            data = <LoadingSection />
        }

        if (potentialSellCosts && potentialSellCosts.get('type') === POTENTIAL_COST) {
            const dataPotentialCosts = potentialSellCosts.get('details').toJS()[0];
            const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
            const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
            const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
            const formatAmount = `${amount} ${currency}`
            const tooltipIcon = __CONTACT_CENTER__ ? ccIcon : privateIcon;
            const tooltipTarget = (<img className="broker-ex-ant-cost__item-tooltip" src={tooltipIcon}></img>);
            const tooltip = potentialSellCosts.getIn(['total','tooltipKey']) ? (
                <OKTooltip
                    title={formatText('brokerAlternativeFundsBuyStep2-exantCost_potentialCostTooltip_title')}
                    content={formatText('brokerAlternativeFundsBuyStep2-exantCost_potentialCostTooltip_content')}
                    placement="top"
                    type={"custom"}
                    target={tooltipTarget}
                    offset={[0, -15]}
                />
            ) : null;

            const text = `${formatText('brokerAlternativeFundsBuyStep2-exantCost_potentialCost_footer')} ${formatAmount} (${immPercentage})`
            const stylesForText = __CONTACT_CENTER__
              ? 'broker-ex-ant-cost__section-cc'
              : 'hire-investment-description__cost-section';
            potentialSellCostsText = (
                <div className={stylesForText}>
                    {text}
                </div>
            );
        }

        return (
            <div className="hire-investment-description__right-column-container">
                {data}
                <div>
                    {potentialSellCostsText}
                </div>
                <div className="broker-ex-ant-cost__section-total-separator" />
                <div className="hire-investment-description__comision">
                <FormattedText
                        value="brokerAlternativeFundsBuyStep2-gestor_commision"
                    />
                </div>
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="hire-investment-description__title-description">
                    {title}
                </div>
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                <span className="hire-investment-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immInvestmentFunds } = this.props;
        const dataExAnt = immInvestmentFunds.getIn(['fetchDataExt', 'response']);
        const potentialSellCostFunds  = dataExAnt && dataExAnt.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_FUNDS_COSTS
        );

        return (
            <div className="hire-investment-description__web-wrapper">
                <div className="hire-investment-description__title-description">
                    <FormattedText
                        value="brokerAlternativeFundsBuyStep2-description"
                    />
                </div>
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                {potentialSellCostFunds && potentialSellCostFunds.get('type') === POTENTIAL_COST_TYPE &&
                    <span className="hire-investment-description__footer">
                        <FormattedText
                            value="brokerAlternativeFundsBuyStep2-extantCost_footer_description"
                        />
                    </span>
                }
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="hire-investment-description__block-info">
                {this.buildDetails(
                    formatText('brokerAlternativeFundsBuyStep2-extantCost_description_cc'),
                    formatText('brokerAlternativeFundsBuyStep2-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExtantCostDetails.propTypes = {
    immInvestmentFunds: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immBrokerETFsProduct: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = ExtantCostDetails;

export default ExtantCostDetails;
